<template>
  <div class="view-container">
    <div class="flex flex-col justify-around items-center">
      <div class="max-w-md w-full sm:w-1/2 lg:w-1/3 xl:w-1/3 flex flex-wrap content-center justify-center">

        <ValidationObserver class="w-full" ref="validator" v-slot="{ invalid }">
          <form @submit.prevent="submit()">

            <base-input :label-placeholder="$t('clients.table.name')" :name="$t('clients.table.name')"
                        class="w-full" rules="required|alpha_spaces"
                        v-model="client.name"/>

            <base-input :label-placeholder="$t('clients.table.address')" :name="$t('clients.table.address')"
                        class="w-full"
                        v-model="client.address"/>

            <base-input :label="$t('clients.table.email')" :label-placeholder="$t('clients.table.email')"
                        :name="$t('clients.table.email')" class="w-full" type="email"
                        v-model="client.email"/>

            <base-input :label-placeholder="$t('clients.table.phone')"
                        :name="$t('clients.table.phone')" class="w-full"
                        v-model="client.phone"/>

            <base-input :label-placeholder="$t('clients.table.vat_number')"
                        :name="$t('clients.table.vat_number')" class="w-full"
                        v-model="client.vat_number"/>

            <base-button :disabled="invalid" :loading="loading" button="filled" class="w-full mb-5 mt-2" color="success"
                         type="submit">
              {{ action }}
            </base-button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ClientDetailsComponent",
    props: {
      client: {
        type: Object,
        required: true
      },
      action: {
        type: String,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      async submit () {
        const isValid = await this.$refs.validator.validate();
        if (!isValid) return;
        this.$emit('confirm')
      },
    },
  }
</script>

<style lang="scss">
</style>
